import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function Location({ member }) {
  return (

    <ValueItem
      icon="location-icon"
      label="Location"
    >
      {member.location}
    </ValueItem>
  );
}

Location.propTypes = {
  member: PropTypes.object.isRequired,
};
